import clsx from "clsx";
import { DetailedHTMLProps, FC, forwardRef, InputHTMLAttributes } from "react";
import styles from "./FormFields.module.scss";

type Props = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

const InputField: FC<Props> = forwardRef((props, ref) => (
  <div className={styles.field}>
    <input
      {...props}
      ref={ref}
      id={props.name}
      className={clsx({ [styles.disabled]: props.disabled })}
    />
  </div>
));

InputField.displayName = "InputField";

export default InputField;
